const PASSWORD_GROUPS = Object.freeze([
  "abcdefghijkmnopqrstuvwxyz",
  "ABCDEFGHJKLMNPQRSTUVWXYZ",
  "23456789",
  "!@#$%*-_?",
]);
const PASSWORD_CHARACTERS = PASSWORD_GROUPS.join("");

const secureRandomIndex = (maxExclusive, cryptoProvider) => {
  const acceptedLimit = Math.floor(256 / maxExclusive) * maxExclusive;
  const bytes = new Uint8Array(1);

  do {
    cryptoProvider.getRandomValues(bytes);
  } while (bytes[0] >= acceptedLimit);

  return bytes[0] % maxExclusive;
};

export const generateSecurePassword = (
  length = 16,
  cryptoProvider = typeof window !== "undefined" ? window.crypto : undefined,
) => {
  if (!Number.isInteger(length) || length < 12 || length > 72) {
    throw new Error("La longueur du mot de passe doit être comprise entre 12 et 72.");
  }
  if (!cryptoProvider || typeof cryptoProvider.getRandomValues !== "function") {
    throw new Error("La génération sécurisée de mot de passe est indisponible.");
  }

  const characters = PASSWORD_GROUPS.map(
    (group) => group[secureRandomIndex(group.length, cryptoProvider)],
  );

  while (characters.length < length) {
    characters.push(
      PASSWORD_CHARACTERS[
        secureRandomIndex(PASSWORD_CHARACTERS.length, cryptoProvider)
      ],
    );
  }

  for (let index = characters.length - 1; index > 0; index -= 1) {
    const swapIndex = secureRandomIndex(index + 1, cryptoProvider);
    [characters[index], characters[swapIndex]] = [
      characters[swapIndex],
      characters[index],
    ];
  }

  return characters.join("");
};

export const copyCredential = async (value) => {
  if (
    !value ||
    typeof navigator === "undefined" ||
    !navigator.clipboard?.writeText
  ) {
    throw new Error("La copie automatique est indisponible.");
  }
  await navigator.clipboard.writeText(value);
};
